import { Component, OnInit} from '@angular/core';
import { StandardsGrowthReportModel, StandardGrowthModel } from 'src/app/Elearning-Models';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { CurriculumService } from 'src/app/Services/curriculum.service';
import { ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import { StandardsGrowthPopupComponent } from './standards-growth-popup/standards-growth-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-curriculum-standards-course-report',
  templateUrl: './curriculum-standards-course-report.component.html',
  styleUrls: ['./curriculum-standards-course-report.component.scss']
})
export class CurriculumStandardsCourseReportComponent implements OnInit {
  
  dataService: CurriculumService;
  dataReceived: boolean = false;
  standardsData: StandardsGrowthReportModel;
  classID: number;

  suggestedCount: number;
  suggestedComplete: number;
  totalComplete: number;

  containerHeight: string;



  constructor(
    private serviceFactory: IServiceFactory,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private location: Location
  ) {
    this.dataService = this.serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
        this.classID = params.ClassID;

        this.dataService.GetStandardsGrowthReport(this.classID).subscribe(result => {
          if(result){
            this.standardsData = result;
            this.suggestedCount = this.standardsData.Standards.filter(s => s.Suggested).length;
            this.suggestedComplete = this.standardsData.Standards
            .filter(s => s.Suggested)
            .filter(s => s.ProficientLessons == s.LessonProgress.length).length;


            this.totalComplete = this.standardsData.Standards.filter(s => s.ProficientLessons == s.LessonProgress.length).length;

            this.containerHeight = ((47*this.standardsData?.Standards.length)+245).toString() + "px";
          }
          this.dataReceived = true;
        });

    });
    
  }


  redirectToViewWorkFromAttempt(data){

  }


  back(){
    this.location.back();
  }

  openDetails(standard: StandardGrowthModel){
    this.dialog.open(StandardsGrowthPopupComponent, {
      data: {
        standard: standard
      },
    });
  }

  
}
